<template lang="pug">
  .metric(@click="$emit('click')")
    .metric__val
      span.h3-m(v-html="value")
      template(v-if="units")
        | &nbsp;
        span.metric__units {{ units }}
    .metric__name(v-html="name")
</template>

<script>
export default {
  name: 'MetricsItem',
  props: {
    value: [Number, String],
    name: String,
    units: String
  }
}
</script>

<style lang="scss" scoped>
  .metric {
    @include base-sm-shadow;
    @include text-xs;
    font-weight: $font-weight-semibold;
    height: 100%;
    text-align: center;
    padding: 12px;

    &_hover {
      cursor: pointer;
      transition: $transition-default;

      .no-touch &:hover {
        color: $color-primary;
      }
    }

    &__val {
      white-space: nowrap;
    }

    &__units {
      @include text-xs;
      white-space: nowrap;
    }
  }
</style>
